import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logo } from '../../assets';
import { APP_VERSION } from '../../constants/appVersion';
import axios from '../../library/axios';
import '../cpanel/cpanel-login.css';
import './landing.css';
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const LandingPage = () => {
  const navigate = useNavigate();
  const [checkingDefault, setCheckingDefault] = useState(true);

  useEffect(() => {
    document.title = 'Speak Hospital by Lamkprs';

    const checkDefaultTenant = async () => {
      try {
        const { data } = await axios({
          url: '/tenants/default',
          method: 'GET',
        });
        if (data && data.defaultTenant && data.defaultTenant.slug) {
          navigate(`/hospitals/${data.defaultTenant.slug}`, { replace: true });
        } else {
          setCheckingDefault(false);
        }
      } catch (err) {
        notifyApiLoadError(err, 'pages/landing/index.checkDefaultTenant');
        setCheckingDefault(false);
      }
    };

    checkDefaultTenant();
  }, [navigate]);

  if (checkingDefault) {
    return null;
  }

  return (
    <div className="speak-landing">
      <div className="speak-landing__body">
        <div className="cpanel-login__brand-inner">
          <img alt="LAM-KPRS" src={logo} className="cpanel-login__logo" />

          <header className="cpanel-login__headings text-center">
            <p className="cpanel-login__welcome">Selamat Datang di</p>
            <h1 className="cpanel-login__title">
              S&nbsp;P&nbsp;E&nbsp;A&nbsp;K&nbsp;&nbsp;H&nbsp;O&nbsp;S&nbsp;P&nbsp;I&nbsp;T&nbsp;A&nbsp;L
            </h1>
            <p className="cpanel-login__subtitle">Sistem Pengelolaan Akreditasi LAM-KPRS</p>
          </header>

          <div className="cpanel-login__intro">
            <p className="cpanel-login__intro-desc">
              <strong>SPEAK HOSPITAL</strong> adalah platform digital terintegrasi yang dikembangkan oleh{' '}
              <strong>LAM-KPRS</strong> untuk mendukung proses akreditasi Rumah Sakit dan kegiatan Surveior
              secara efisien, terdokumentasi, dan transparan.
            </p>
            <hr className="cpanel-login__intro-divider" />
            <p className="cpanel-login__intro-quote">
              Bersama menuju mutu pelayanan rumah sakit yang unggul melalui akreditasi terstandarisasi.
            </p>
          </div>
        </div>
      </div>

      <footer className="speak-landing__footer">
        {new Date().getFullYear()}© | LAM-KPRS v{APP_VERSION}
      </footer>
    </div>
  );
};

export default LandingPage;
